// AnimatePresenceWrapper.tsx
import { AnimatePresence, AnimatePresenceProps } from "framer-motion";
import { ReactNode } from "react";

interface Props extends AnimatePresenceProps {
  children: ReactNode;
}

export const AnimatePresenceWrapper = ({ children, ...rest }: Props): JSX.Element => {
  return (
    AnimatePresence({ ...rest, children }) as unknown as JSX.Element
  );
};
